import { FormBase } from 'core/components';
import _ from 'lodash';

export default class ProductImportForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.state.options.set({
			showErrorsOnReset: true,
		});
	}

	setup() {
		return {
			fields: [
				{
					name: 'sellerId',
					label: 'PRODUCTVIEW.SELLER',
				},
			],
		};
	}
}
